import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './HomePage';
import Register from './Register';
import ConfirmEmail from './ConfirmEmail';
import Login from './Login';
import Header from './Header';
import PrivateProfile from './PrivateProfile';
import Spiritual from './topics/Spiritual/Spiritual';
import Physical from './topics/Physical/Physical';
import Intellectual from './topics/Intellectual/Intellectual';
import Relational from './topics/Relational/Relational';
import Emotional from './topics/Emotional/Emotional';
import Meditation from './topics/Spiritual/Meditation';
import Nature from './topics/Spiritual/Nature';
import Gratitude from './topics/Spiritual/Gratitude';
import Exercise from './topics/Physical/Exercise';
import Cardio from './topics/Physical/Cardio';
import Strength from './topics/Physical/Strength';
import Flexibility from './topics/Physical/Flexibility';
import Nutrition from './topics/Physical/Nutrition';
import BalancedDiet from './topics/Physical/BalancedDiet';
import IntermittentFasting from './topics/Physical/IntermittentFasting'; 
import ProlongedFasting from './topics/Physical/ProlongedFasting.js';   
import Sleep from './topics/Physical/Sleep.js';
import LifelongLearning from './topics/Intellectual/LifelongLearning.js';
import Reading from './topics/Intellectual/Reading.js';
import Language from './topics/Intellectual/Language.js';
import BrainGames from './topics/Intellectual/BrainGames.js';
import Relationships from './topics/Relational/Relationships.js';
import Communication from './topics/Relational/Communication.js';
import Listening from './topics/Relational/Listening.js';
import Speaking from './topics/Relational/Speaking.js';
import ConflictResolution from './topics/Relational/ConflictResolution.js';
import Stress from './topics/Emotional/Stress.js';
import Resilience from './topics/Emotional/Resilience.js';
import EmotionalIntelligence from './topics/Emotional/EmotionalIntelligence.js';
import Hydration from './topics/Physical/Hydration.js';
import ForumHomePage from './forums/ForumHomePage.js';
import SpiritualForum from './forums/Spiritual/TemplateForum.js';
import Blog from './blog/Blog.js';
import BlogDetail from './blog/BlogDetail.js';
import BlogPostForm from './blog/BlogPostForm.js';
import MeditationForum from './forums/Spiritual/MeditationForum.js';
import AddVideoForm from './AddVideoForm.js';
import GratitudeTracker from './GratitudeTracker.js';
import WeightTracker from './WeightTracker.js';
import Footer from './Footer.js';
import ForgotPassword from './ForgotPassword.js';
import Leaderboard from './leaderboard/Leaderboard.js';
import IndividualLeaderboard from './leaderboard/IndividualLeaderboard.js';
import CompanyLeaderboard from './leaderboard/CompanyLeaderbaord.js';
import GroupLeaderboard from './leaderboard/GroupLeaderboard.js';
import CreateGroup from './group/CreateGroup.js';
import GroupPage from './group/GroupPage.js';
import GroupForumTemplate from './group/GroupForumTemplate.js';
import JoinGroup from './group/JoinGroup.js';
import Habits from './topics/Habits/Habits.js';
import ResetPassword from './ResetPassword.js';
import GroupAdminPage from './group/GroupAdminPage.js';
import TableOfContents from './components/TableofContents.js';
import topicsData from './data/topicsData.js';
import ScrollToTop from './components/ScrollToTop'; 
import GratitudeLeaderboard from './leaderboard/GratitudeLeaderboard.js';
import HabitBasics from './topics/Habits/HabitBasics.js';
import WeightTracker2 from './WeightTracker2.js';




const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/topics/contents"
          element={<TableOfContents topicsData={topicsData} />}
        />
        <Route path="/register" element={<Register />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<PrivateProfile />} />
        <Route path="/spiritual" element={<Spiritual />} />
        <Route path="/physical" element={<Physical />} />
        <Route path="/intellectual" element={<Intellectual />} />
        <Route path="/relational" element={<Relational />} />
        <Route path="/emotional" element={<Emotional />} />
        <Route path="/spiritual/meditation" element={<Meditation />} />
        <Route path="/spiritual/nature" element={<Nature />} />
        <Route path="/spiritual/gratitude" element={<Gratitude />} />
        <Route path="/physical/exercise" element={<Exercise />} />
        <Route path="/exercise/cardio" element={<Cardio />} />
        <Route path="/exercise/strength" element={<Strength />} />
        <Route path="/exercise/flexibility" element={<Flexibility />} />
        <Route path="/physical/nutrition" element={<Nutrition />} />
        <Route path="/physical/diet" element={<BalancedDiet />} />
        <Route path="/physical/fasting" element={<IntermittentFasting />} />
        <Route path="/physical/hydration" element={<Hydration />} />
        <Route path="/nutrition/prolonged" element={<ProlongedFasting />} />
        <Route path="/physical/sleep" element={<Sleep />} />
        <Route path="/intellectual/lifelonglearning" element={<LifelongLearning />} />
        <Route path="/intellectual/reading" element={<Reading />} />
        <Route path="/intellectual/language" element={<Language />} />
        <Route path="/intellectual/braingames" element={<BrainGames />} />
        <Route path="/relational/relationships" element={<Relationships />} />
        <Route path="/relational/communication" element={<Communication />} />
        <Route path="/relational/listening" element={<Listening />} />
        <Route path="/relational/speaking" element={<Speaking />} />
        <Route path="/relational/conflictresolution" element={<ConflictResolution />} />
        <Route path="/emotional/stress" element={<Stress />} />
        <Route path="/emotional/resilience" element={<Resilience />} />
        <Route path="/emotional/emotionalintelligence" element={<EmotionalIntelligence />} />
        <Route path="/nutrition/hydration" element={<Hydration />} />
        <Route path="/add-video" element={<AddVideoForm />} />
        <Route path="/gratitude" element={<GratitudeTracker />} />
        <Route path="/weight-tracker" element={<WeightTracker />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/individual-leaderboard" element={<IndividualLeaderboard />} />
        <Route path="/company-leaderboard" element={<CompanyLeaderboard />} />
        <Route path="/group-leaderboard" element={<GroupLeaderboard />} />
        <Route path="/create-group" element={<CreateGroup />} />
        <Route path="/group/:groupId" element={<GroupPage />} />
        <Route path="/group/:groupId/forum" element={<GroupForumTemplate />} />
        <Route path="/join-group" element={<JoinGroup />} />
        <Route path="/habits" element={<Habits />} />
        <Route path="/group/:groupName" exact component={GroupPage} />
        <Route path="/group/:groupId/admin" element={<GroupAdminPage />} />
        <Route path="/gratitude-leaderboard" element={<GratitudeLeaderboard />} />
        <Route path="/habits/basics" element={<HabitBasics />} />
        <Route path="/weight-tracker2" element={<WeightTracker2 />} />

        

      
        {/* Dynamic Forum Routes by Category */}
        <Route path="/forum" element={<ForumHomePage />} />
        <Route path="/forum/:category" element={<SpiritualForum />} /> {/* Dynamic category */}
        <Route path="/forum/:category" element={<MeditationForum />} />

        {/* Blogs */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:blogId" element={<BlogDetail />} /> {/* Fixed dynamic route */}
        <Route path="/blog/new" element={<BlogPostForm />} />

      </Routes>
      <Footer />
    </Router>
  );
};

export default App;

